module.exports = __webpack_public_path__ + "img/apply_success.a733e4d8.png";